<template>
  <div class="mobile_render">
    <myHeader />
    <!-- banner模块 -->
    <!-- <div class="banner">
      <p style="font-size: 34px; font-weight: 900">实时渲染与交互</p>
      <p style="font-size: 16px; font-weight: 700; margin-top: 10px">
        轻松构建复杂且引人入胜的互动场景
      </p>
    </div> -->

    <div class="banner">
      <canvas id="threeCanvas" ref="threeCanvas"></canvas>
      <div class="banner_content">
        <p style="font-size: 26px; font-weight: 700" class="banner_content_p">
          实时渲染与交互
        </p>
        <p style="font-size: 12px; font-weight: 700; margin-top: 10px" class="banner_content_p1">
          轻松构建复杂且引人入胜的互动场景
        </p>
        <div class="callMe" @click="jumpTo('/CaseDemonstration#CallMe')">联系我们</div>
      </div>
    </div>

    <!-- 先刷重点模块 -->
    <div class="key_points">
      <p style="font-size: 26px; font-weight: 700; margin-bottom: 10px" class="key_p">
        先刷重点
      </p>
      <p style="font-size: 14px; color: rgba(255, 255, 255, 0.64)" class="key_p1">
        实时渲染与交互的优势
      </p>
      <img v-show="isFirstImage1"
        src="https://download.hecoos.com/enlightv/2025-17/8dc963c65351d2b39e1a034934b48eea.png" alt="" />
      <img v-show="isFirstImage2"
        src="https://download.hecoos.com/enlightv/2025-17/c52ef6a9594d1abf55fea0e923e8117b.png" alt="" />
      <div class="button_container" ref="button_list">
        <button :class="{ btn: true, active: isBtn1Active }" @click="switchContent(1)">
          加载实时渲染Block/SDK
        </button>
        <button :class="{ btn: true, active: isBtn2Active }" @click="switchContent(2)">
          追踪、传感器接入
        </button>
        <div class="underline" :style="{
          width: buttonUnderlineWidth + 'px',
          left: buttonUnderlineLeft + 'px',
        }"></div>
      </div>
      <div class="render_text">
        <p v-show="isFirstImage1">
          多种实时渲染引擎（如
          <span>Notch、Unity3D、Unreal Engine、TouchDesigner</span>
          等）轻松接入，可通过<span>SPOUT、NDI、硬件采集卡</span>等方式采集互动画面
        </p>
        <p v-show="isFirstImage2">
          追踪系统数据接入<span>（VICON、blacktrax、optitrack、stype、Mo-sys、Redspy等）</span>传感器接入<span>（Radar、红外、压感、kinnect等）</span>开源硬件对接<span>（ARDUINO、树莓派等）</span>
        </p>
      </div>
    </div>

    <!-- 应用场景模块 -->
    <div class="application_scene">
      <p style="font-size: 26px; margin-bottom: 14px" class="application_scene_p">应用场景</p>
      <p style="font-size: 14px; color: rgba(255, 255, 255, 0.64)" class="application_scene_p1">
        投影映射的实际应用
      </p>
      <sceneBanner :applicationInfo="applicationInfo" />

      <!-- <mobileRenderBanner :applicationInfo="applicationInfo" /> -->
    </div>

    <!-- 产品模块 -->
    <div class="product">
      <div class="tab">
        <p style="font-size: 16px" class="default_font">产品</p>
        <p style="font-size: 26px; font-weight: 700; margin-top: 12px" class="product_tab_p1">
          您的虚拟制作工具包
        </p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span :class="{ select: currentTabIndex === 0 }" @click="selectTab(0)">
            <!-- Server-C -->
          </span>
          <span :class="{ select: currentTabIndex === 1 }" @click="selectTab(1)">
            Server-D
          </span>
          <span :class="{ select: currentTabIndex === 2 }" @click="selectTab(2)">
            Server-R
          </span>
          <div class="underline" :style="{
            width: underlineWidth + 'px',
            left: underlineLeft + 'px',
          }"></div>
        </div>
      </div>
      <!-- 产品内容部分 -->
      <div>
        <div class="content">
          <div class="studio" v-show="showContents[0]">
            <img src="https://download.hecoos.com/enlightv/2025-17/04d5ec07fa899de9a432f1229ce2e14a.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700" class="textContent_p">Server-C</p>
              <p class="render_p">
                依托 hecoos
                工作流程，最大限度管控从展演的灵感到最终落地呈现的各个环节，从而践行“设计即实现”的产品设计理念。
              </p>
              <button @click="jumpTo('/mediaServer?section=1#tab')">了解更多</button>
            </div>
          </div>
          <div class="studio" v-show="showContents[1]">
            <img src="https://download.hecoos.com/enlightv/2025-17/04d5ec07fa899de9a432f1229ce2e14a.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700" class="textContent_p">Server-D</p>
              <p class="render_p">
                依托 hecoos
                工作流程，最大限度管控从展演的灵感到最终落地呈现的各个环节，从而践行“设计即实现”的产品设计理念。
              </p>
              <button @click="jumpTo('/mediaServer?section=0#tab')">了解更多</button>
            </div>
          </div>
          <div class="studio" v-show="showContents[2]">
            <img src="https://download.hecoos.com/enlightv/2025-17/84ed7b41f8f729ee36615a27ffed63f9.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700" class="textContent_p">Server-R</p>
              <p class="render_p">
                面对繁重复杂的实时渲染任务时，hecoos
                Server-R超强渲染能力亦能为虚拟内容创作者提供贴心保障。
              </p>
              <button @click="jumpTo('/mediaServer?section=2#tab')">了解更多</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <myCreativity :imgUrl="imgUrl" />
    <myFooter />
  </div>
</template>

<script>
import myHeader from "@/components/mobile/myHeader.vue";
import myFooter from "@/components/mobile/myFooter.vue";
import sceneBanner from "@/components/mobile/scene_banner.vue";
import myCreativity from "@/components/mobile/myCreativity.vue";
import G from '@/utils/render_interaction_canvas.js';

export default {
  data() {
    return {
      isFirstImage1: true,
      isFirstImage2: false,
      // 用于控制按钮的激活状态
      isBtn1Active: true,
      isBtn2Active: false,
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 1,
      underlineWidth: 0,
      underlineLeft: 0,
      currentButtonIndex: 1,
      buttonUnderlineWidth: 0,
      buttonUnderlineLeft: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      applicationInfo: [
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/8e0211a35160113c1a748086d6006798.png',
          title: "演唱会",
          msg: "hecoos凭借对多种实时渲染引擎（如 Notch、Unity3D、Unreal Engine、TouchDesigner 等）的兼容以及追踪数据的精准接入，使得酷炫的视效与歌手的演绎随行，缔造独一无二的多感官盛宴。",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/bc8e64755519ac04a0d1b1b398e9af1e.png',
          title: "舞台演出",
          msg: "在共同面对hecoos的预演界面时，艺术家与工程师能够协作探讨并清晰确立方案的每一处细节。为演出的顺利推进与精彩呈现奠定了坚实且可靠的基础。",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/d464d7fad4f317f5f8e2aa2c6e5d2738.png',
          title: "沉浸式展览",
          msg: "hecoos将多种实时渲染引擎与传感器轻松接入与视频、灯光、机械等设备巧妙结合，统一管控播放，为艺术家搭建创意实现平台，充分释放艺术创作的无限可能。",
        },
      ],
      imgUrl: 'https://download.hecoos.com/enlightv/2025-17/519b1d101bbfe0e2b5f382ad27d8202a.png'
    };
  },
  components: {
    myHeader,
    myFooter,
    myCreativity,
    sceneBanner,
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      this.buttonUpdateUnderlinePosition();
      this.buttonSetupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
      window.addEventListener("resize", this.buttonUpdateUnderlinePosition);
    });
    const canvas = this.$refs.threeCanvas;
    const options = {
      // 这里可以传入自定义参数
    };
    this.threeScene = G(canvas, options);
    this.spheres = this.threeScene.spheres;
  },
  beforeDestroy() {
    if (this.threeScene) {
      this.threeScene.dispose();
    }
    window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener("resize", this.buttonUpdateUnderlinePosition);
  },
  methods: {
    jumpTo(path) {
      // console.log(path);
      this.$router.push(path)
    },
    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },

    // 导航切换底部跟随
    buttonUpdateUnderlinePosition() {
      const switchList = this.$refs.button_list;
      if (switchList) {
        const button =
          switchList.querySelectorAll("button")[this.currentButtonIndex - 1];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = button.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(button);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.buttonUnderlineWidth = spanRect.width + paddingLeft - paddingRight;

        // 计算去除 padding 后的左侧偏移量
        this.buttonUnderlineLeft =
          spanRect.left - switchListRect.left - paddingLeft + paddingRight;
      }
    },
    // 文字宽度变化监听
    buttonSetupSpanResizeObservers() {
      const buttons = this.$refs.button_list.querySelectorAll("button");
      const resizeCallback = () => {
        this.buttonUpdateUnderlinePosition();
      };
      buttons.forEach((button) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(button);
      });
    },
    // 切换内容和按钮激活状态的方法
    switchContent(type) {
      this.currentButtonIndex = type;
      this.buttonUpdateUnderlinePosition();
      if (type === 1) {
        this.isFirstImage1 = true;
        this.isFirstImage2 = false;
        this.isBtn1Active = true;
        this.isBtn2Active = false;
      } else {
        this.isFirstImage1 = false;
        this.isFirstImage2 = true;
        this.isBtn1Active = false;
        this.isBtn2Active = true;
      }
    },
    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mobile_xty.scss";
.callMe {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 12px;
      transition: 0.3s ease;
      cursor: pointer;
      color: white;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    @media screen and (min-width: 768px) {
      .callMe {
      width: 180px;
      height: 50px;
      line-height: 50px;
      border-radius: 30px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    }
</style>